module.exports = __webpack_public_path__ + "static/media/plusicon.2ac30210.png";